import React from 'react';

const TimelineDocumentIcon = ({ fill }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 17.3"
      xmlSpace="preserve"
      fill={fill}
      className="card-icon"
    >
      <title>Document</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-577.000000, -1695.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Documents-Attached" transform="translate(0.000000, 792.000000)">
                <g id="Icon" transform="translate(31.000000, 0.000000)">
                  <g id="Avatar">
                    <g id="file-alt-light" transform="translate(14.000000, 19.000000)">
                      <path
                        id="Shape"
                        fill={fill}
                        d="M12.5,3.3L9.7,0.5C9.4,0.2,9,0,8.5,0H1.6C0.7,0,0,0.7,0,1.6v14.1c0,0.9,0.7,1.6,1.6,1.6h9.8
                        c0.9,0,1.6-0.7,1.6-1.6V4.5C13,4,12.8,3.6,12.5,3.3z M11.8,4.1c0.1,0.1,0.1,0.2,0.1,0.3H8.7V1.1c0.1,0,0.2,0.1,0.3,0.1
                        L11.8,4.1z M11.4,16.3H1.6c-0.3,0-0.5-0.2-0.5-0.5V1.6c0-0.3,0.2-0.5,0.5-0.5h6v3.5c0,0.5,0.4,0.8,0.8,0.8h3.5v10.3
                        C11.9,16,11.7,16.3,11.4,16.3z M9.8,8v0.3c0,0.2-0.2,0.4-0.4,0.4H3.7c-0.2,0-0.4-0.2-0.4-0.4V8c0-0.2,0.2-0.4,0.4-0.4h5.7
                        C9.6,7.6,9.8,7.8,9.8,8z M9.8,10.2v0.3c0,0.2-0.2,0.4-0.4,0.4H3.7c-0.2,0-0.4-0.2-0.4-0.4v-0.3c0-0.2,0.2-0.4,0.4-0.4h5.7
                        C9.6,9.8,9.8,9.9,9.8,10.2z M9.8,12.3v0.3c0,0.2-0.2,0.4-0.4,0.4H3.7c-0.2,0-0.4-0.2-0.4-0.4v-0.3c0-0.2,0.2-0.4,0.4-0.4
                        h5.7C9.6,11.9,9.8,12.1,9.8,12.3z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineDocumentIcon;
